// src/automation/AutomationEvents.js

export const AutomationEvents = {
  // Worker lifecycle
  WORKER_REGISTERED: "worker.registered",
  WORKER_APPROVED: "worker.approved",
  WORKER_READY: "worker.ready",
  WORKER_UPDATED: "worker.updated",
  WORKER_DEACTIVATED: "worker.deactivated",

  // Facility
  FACILITY_ASSIGNED: "facility.assigned",
  FACILITY_TRANSFERRED: "facility.transferred",

  // Compliance
  DOCUMENT_UPLOADED: "document.uploaded",
  DOCUMENT_APPROVED: "document.approved",
  DOCUMENT_REJECTED: "document.rejected",

  // Shift lifecycle
  SHIFT_CREATED: "shift.created",
  SHIFT_REQUESTED: "shift.requested",
  SHIFT_ASSIGNED: "shift.assigned",
  SHIFT_ACCEPTED: "shift.accepted",
  SHIFT_DECLINED: "shift.declined",
  SHIFT_ACTIVATED: "shift.activated",
  SHIFT_ENROUTE: "shift.enroute",
  SHIFT_ARRIVED: "shift.arrived",
  SHIFT_COMPLETED: "shift.completed",
  SHIFT_CANCELLED: "shift.cancelled",

  // Finance
  PAYROLL_GENERATED: "payroll.generated",
  INVOICE_GENERATED: "invoice.generated",
  INVOICE_PAID: "invoice.paid",

  // Notifications
  ALERT_CREATED: "alert.created",
};